import { LOGIN_REQUESTING, LOG_OUT, LOGOUT_REQUESTING } from './constants';

export const loginRequest = function loginRequest({ username, password }) {
  return {
    type: LOGIN_REQUESTING,
    username,
    password,
  };
};

export const Logout = function logout() {
  return {
    type: LOG_OUT,
  };
};

export const logoutRequest = function logoutRequest({ user, session }) {
  return {
    type: LOGOUT_REQUESTING,
    username: user,
    session,
  };
};
